import * as React from 'react';
import { PayAndPublishContainer } from '../ActionButtonsDesktop/components';
import { SaveDraftContainer } from '../SaveDraft';
import * as styles from './HiddenBaseDesktop.css';

export const HiddenBaseDesktop = () => {
  return (
    <div className={styles['wrapper']}>
      <PayAndPublishContainer />

      <div className={styles['draft_button']}>
        <SaveDraftContainer />
      </div>
    </div>
  );
};
